// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--ch3SI","hand":"_93444fe79c--hand--hIE2C"};